<style scoped lang="scss">
@keyframes example {
  0%   {top: 45%;opacity: 0;}
  50% {top: 50%;opacity: 1;}
  100% {top: 50%;opacity: 0;}
}
.message{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;
    .message_info{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        transition: all 0.3s ease;
        opacity: 1;
        padding: 10px 20px;
        background: rgba($color: #000000, $alpha: .8);
        color: #fff;
        border-radius: 8px;
        animation-name: example;
        animation-duration: 2s;
        animation-iteration-count: 1;
    }

}
</style>
<template>
    <div class="message" v-show="Message">
        <div class="message_info">{{ msg }}</div>
    </div>
</template>

<script>
export default {
  name: "eperAddCartSuccMessage",
  computed:{
    Message:function(){
      return this.$store.state.MessageConfig.showMessage;
    },
    msg:function(){
      return this.$store.state.MessageConfig.msg;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/eperAddCartSuccMessage.vue